import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  OnDestroy,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OpsSubscriptionModalService, SubscriptionStatus } from '@ops/shared-types';
import { Subscription } from 'rxjs';

interface SortOption {
  sortBy: number;
  sortDirection: number;
}

@Component({
  selector: 'ops-project-status',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ops-project-status.component.html',
  styleUrl: './ops-project-status.component.scss',
})
export class OpsProjectStatusComponent implements OnDestroy {
  public _projectStatusId = -1;
  public _projectStatusName = '';

  // TODO SIMKE I LOSMI I SLOBA! :D
  // MEMORY FROM 4/24/2025

  @Input() set selectedStatus(val: string) {
    // console.log('CHANGED STATUS', val);

    // if(this._projectStatus?.id !== +val) {
    const matchStatus = this.statusOptions.find((so) => so.id === +val);

    this._projectStatusId = (matchStatus ?? this.statusOptions[0]).id;
    this._projectStatusName = (matchStatus ?? this.statusOptions[0]).name;
    // }
  }

  @Input() isPreview?: boolean;
  @Input() userRole?: string;

  @Output() statusChanged: EventEmitter<string> = new EventEmitter<string>();

  isExpanded = 0;
  confirmSubscription: Subscription;

  closeTimeout: any = null;
  mouseLeft = false;
  mouseEnter = false;

  statusOptions = [
    {
      id: 0,
      name: 'Pitching',
    },
    {
      id: 1,
      name: 'Ongoing',
    },
    {
      id: 2,
      name: 'Completed',
    },
    {
      id: 3,
      name: 'Submitted',
    },
    {
      id: 4,
      name: 'Cancelled',
    },
  ];

  private languageSubscription: Subscription;

  get isAdmin(): boolean {
    return this.userRole === 'admin';
  }

  constructor(
    private elementRef: ElementRef,
    private translateService: TranslateService,
    private modalService: OpsSubscriptionModalService
  ) {
    this.isExpanded = 0;
    this.updateStatusNames();
    
    // Subscribe to language changes
    this.languageSubscription = this.translateService.onLangChange.subscribe(() => {
      this.updateStatusNames();
    });
  }

  ngOnDestroy() {
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }

  private updateStatusNames() {
    this.statusOptions = [
      {
        id: 0,
        name: this.translateService.instant('Pitching'),
      },
      {
        id: 1,
        name: this.translateService.instant('Ongoing'),
      },
      {
        id: 2,
        name: this.translateService.instant('Completed'),
      },
      {
        id: 3,
        name: this.translateService.instant('Submitted'),
      },
      {
        id: 4,
        name: this.translateService.instant('Cancelled'),
      },
    ];

    // Update the current status name if it exists
    if (this._projectStatusId >= 0) {
      const currentStatus = this.statusOptions.find(so => so.id === this._projectStatusId);
      if (currentStatus) {
        this._projectStatusName = currentStatus.name;
      }
    }
  }

  toggleSort() {
    // console.log('TOGGLE');
    if (this.isExpanded === 1) {
      this.isExpanded = 2;
      return;
    } else if (this.isExpanded === 2) {
      this.isExpanded = 1;
      return;
    } else if (this.isExpanded === 0) {
      this.isExpanded = 1;
      return;
    }
  }

  showConfirmationModal(
    titleText: string,
    bodyText: string,
    confirmationCallBack: () => void
  ) {
    if (this.confirmSubscription?.unsubscribe) {
      this.confirmSubscription.unsubscribe();
    }
    this.confirmSubscription = this.modalService
      .openModal({
        statusType: SubscriptionStatus.CONFIRMATION,
        modalTitle: titleText,
        modalText: bodyText,
      })
      .subscribe((confirmed) => {
        if (confirmed) {
          // User confirmed
          // console.log('User confirmed cancellation');
          confirmationCallBack();
        } else {
          // User declined
          // console.log('User cancelled the action');
        }
      });
  }

  selectOption(optionId: number) {
    if(optionId === 2) {
      // Get translated strings
      const confirmationText = this.translateService.instant('windowConfirm.projectStatus.completeProjectConfirmation');
      const actions = this.translateService.instant('windowConfirm.projectStatus.completeProjectActions');
      const proceedText = this.translateService.instant('windowConfirm.projectStatus.completeProjectProceed');
      
      // Build the HTML with translated content
      const actionsList = actions.map((action: string) => `<li>${action}</li>`).join('');
      const modalBody = `<span class="text-16"><span class="text-left">${confirmationText}</span>
        	<ul>${actionsList}</ul><span class="text-left">${proceedText}</span></span>`;
      
      this.showConfirmationModal(this.translateService.instant('common.confirmation'), modalBody, () => {
        const matchStatus = this.statusOptions.find((so) => so.id === +optionId);

        this._projectStatusId = (matchStatus ?? this.statusOptions[0]).id;
        this._projectStatusName = (matchStatus ?? this.statusOptions[0]).name;
        this.isExpanded = 0;
        this.statusChanged.emit(optionId.toString());
      });
    } else if(optionId === 3) {
      // Check if user is switching to "Submitted" status (ID 3)
      this.showConfirmationModal(
        this.translateService.instant('common.confirmation'),
        this.translateService.instant('windowConfirm.projectStatus.submitProjectConfirmation'),
        () => {
          // User confirmed, proceed with status change
          const matchStatus = this.statusOptions.find((so) => so.id === +optionId);

          this._projectStatusId = (matchStatus ?? this.statusOptions[0]).id;
          this._projectStatusName = (matchStatus ?? this.statusOptions[0]).name;
          this.isExpanded = 0;
          this.statusChanged.emit(optionId.toString());
        }
      );
    } else {
      const matchStatus = this.statusOptions.find((so) => so.id === +optionId);

      this._projectStatusId = (matchStatus ?? this.statusOptions[0]).id;
      this._projectStatusName = (matchStatus ?? this.statusOptions[0]).name;
      this.isExpanded = 0;
      this.statusChanged.emit(optionId.toString());
    }
  }

  startCloseTimeout(waitingTime?: number) {
    clearTimeout(this.closeTimeout);

    const wTime = waitingTime || 200;

    if (this.isExpanded) {
      this.closeTimeout = setTimeout(() => {
        this.isExpanded = 2;
      }, wTime);
    }
  }

  // Cancel close timeout if hovered
  @HostListener('mouseenter')
  onMouseEnter() {
    this.mouseLeft = false;
    this.mouseEnter = true;
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
    }
  }

  // Handle blur and close dropdown after a timeout
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      clearTimeout(this.closeTimeout);
      if (this.isExpanded === 1) {
        this.isExpanded = 2;
      }
    }
  }

  // Reset close timeout if user hovers back
  @HostListener('mouseleave')
  onMouseLeave() {
    this.mouseLeft = true;
    this.startCloseTimeout();
  }
}
